//#region Libraries
//#endregion
//#region Styles
import { Column } from "components/styles";
import {
    Container, 
    Title } from "../../../styles";
//#endregion
//#region Components
import PredefinedEnvironmentControls from "./components/PredefinedEnvironmentControls/PredefinedEnvironmentControls";
import FreeEnvironmentControls from "./components/FreeEnvironmentControls/FreeEnvironmentControls";
import HandlerRadio from "components/CustomRadio/CustomRadio";
import { ENVIRONMENT_FILLING_TYPES } from "views/RefuerzoAcademico/components/FormCreateAcadReinforce/ManualLoadingForm/utils/constants";
import { useEffect } from "react";
//#endregion

const LocationPlaceStep2 = ({
    dataRelatedToForm: {
        environmentList
    },
    form, errors, 
    changeField
}) => {
    const {
        environmentFillingTypeId,
        environment, otherEnvironment
    } = form;
    //#region Functions
    const changeEnvironment = value => {
        changeField("environment", value, false);
    }
    const changeOtherEnvironment = (field, value) => {
        changeField("otherEnvironment", prev => ({
            ...prev,
            [field]: value
        }), prev => ({
            ...prev,
            [field]: false
        }));
    }
    const changeEnvironmentFillingTypeId = value => {
        changeField("environmentFillingTypeId", value);
    }
    //#endregion
    return (
        <Container>
            <Title>Paso 02:</Title>
            <HandlerRadio
                value={environmentFillingTypeId}
                onChange={changeEnvironmentFillingTypeId}
                radiosProps={ENVIRONMENT_FILLING_TYPES.map(({ id, name }) => ({
                    value: id, 
                    label: name
                }))}
                marginBottom="15px"/>
            <Column>
                {environmentFillingTypeId === 1 
                ? <PredefinedEnvironmentControls 
                    environmentList={environmentList}
                    environment={environment}
                    changeEnvironment={changeEnvironment}
                    error={errors.environment}/>
                : environmentFillingTypeId === 2 
                ? <FreeEnvironmentControls 
                    form={otherEnvironment}
                    changeField={changeOtherEnvironment}
                    errors={errors.otherEnvironment}/> 
                : null}
            </Column>
        </Container>
    );
}

export default LocationPlaceStep2;